import React from 'react'
import moment from 'moment'
import { BlogPost } from '@/hooks/useBlogs'
import { Link } from 'react-router'

interface BlogsGridProps {
  blogPosts: BlogPost[]
}

export const BlogsGrid: React.FC<BlogsGridProps> = ({ blogPosts }) => {
  // Function to generate a placeholder image URL if no image is provided
  const getImageUrl = (post: BlogPost) => {
    return post.imageUrl || `/blog-placeholder-${(post.id % 3) + 1}.jpg`
  }

  // Function to get default author image if none provided
  const getAuthorImage = (post: BlogPost) => {
    return (
      post.authorImage ||
      'https://i.ibb.co/gMJP2rdq/man-empty-avatar-photo-placeholder-for-social-networks-resumes-forums-and-dating-sites-male-and-fema.jpg'
    )
  }

  return (
    <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
      {blogPosts.map((blog: BlogPost) => (
        <article
          key={blog.id}
          className="flex max-w-xl flex-col items-start justify-between"
        >
          <div className="flex items-center gap-x-4 text-xs">
            <time dateTime={blog.publishedAt} className="text-gray-500">
              {moment(blog.publishedAt).format('LLL')}
            </time>
            <a
              href="#"
              className="relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100"
            >
              {blog.slug?.toUpperCase()}
            </a>
          </div>
          <div className="group relative">
            <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
              <Link to={`/blogs/${blog.id}`}>
                <span className="absolute inset-0" />
                {blog.title}
              </Link>
            </h3>
            <p className="mt-5 line-clamp-3 text-sm leading-6 text-gray-600">
              {blog.excerpt}
            </p>
          </div>
          <div className="relative mt-8 flex items-center gap-x-4">
            <img
              alt={`author`}
              src={getAuthorImage(blog)}
              className="h-10 w-10 rounded-full bg-gray-50"
            />
            <div className="text-sm leading-6">
              <p className="font-semibold text-gray-900">
                <a href="#">
                  <span className="absolute inset-0" />
                  {blog.authorName}
                </a>
              </p>
              <p className="text-gray-600">{blog.authorPosition}</p>
            </div>
          </div>
        </article>
      ))}
    </div>
  )
}
